import React from 'react';

import Container from './Logout-container';

const ViewComponent = () => <Container />;

ViewComponent.displayName = 'Logout-view';

export default ViewComponent;
